module.exports = __webpack_public_path__ + "media/images/social/vk-86ccc782f6965004628a9f1e24668918.svg";